module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/287.4576fae7.png";